import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IApplication } from './interfaces';

export const getMyApplicationList = (data: IDynamicTableParams) => {
  return instance()
    .post<IApplication[]>('/application/myapplication/list', data)
    .then((response) => response.data);
};

export const getMyApplicationAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/application/availableColumns')
    .then((response) => response.data);
};

export const getMyApplicationAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/application/availableGroupColumns')
    .then((response) => response.data);
};
